import React, { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

import ModalActions from 'components/ModalActions';
import Spin from 'components/Spin';

import Alpaclass from './Alpaclass/index';
import File from './File';
import Nutror from './Nutror';
import Other from './Other';

interface IProps {
  deliveries: any;
  onEditSomething: any;
  offer?: any;
}

const DeliveryList: React.FC<IProps> = ({ deliveries, onEditSomething, offer }) => {
  const [open, setOpen] = useState(false);
  const [onOk, setOnOk] = useState<any>(null);
  const [item, setItem] = useState<any>(null);

  const onEditDelivery = useCallback(
    (newItem: any, oldItem: any) => {
      const newDeliveries = [...deliveries];
      const index = newDeliveries.findIndex((i: any) => i.url === oldItem.url);
      newDeliveries[index] = newItem;
      const oldName = oldItem?.method_name || oldItem.nutror_name;
      const newName = newItem?.method_name || newItem.nutror_name;
      toast.success(`Item ${oldName} alterado para ${newName} com sucesso!`);
      if (onEditSomething) onEditSomething(newDeliveries);
    },
    [deliveries, onEditSomething]
  );

  const onRemoveDelivery = useCallback(
    (itemName: any, index: number) => {
      const confirmOk = () => {
        const nd = deliveries;
        nd.splice(index, 1);
        setOpen(false);
        toast.success(`Item ${itemName} removido com sucesso!`);
        if (onEditSomething) onEditSomething(nd);
      };

      setOpen(true);
      setOnOk(() => confirmOk);
      setItem(itemName);
    },
    [deliveries, onEditSomething]
  );

  const onRemoveFile = useCallback(
    (itemName: any, index: number, file: number) => {
      const confirmOk = () => {
        const nd = [...deliveries];
        nd[index].files.splice(file, 1);
        if (nd[index].files.length === 0) nd.splice(index, 1);
        setOpen(false);
        toast.success(`Item ${itemName} removido com sucesso!`);
        if (onEditSomething) onEditSomething(nd);
      };

      setOpen(true);
      setOnOk(() => confirmOk);
      setItem(itemName);
    },
    [deliveries, onEditSomething]
  );

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <>
      <ul className='m-0 list-none p-0'>
        {deliveries && deliveries.isFetching && <Spin />}
        {deliveries && deliveries.length > 0 ? (
          deliveries.map((d: any, index: number) => {
            switch (String(d.method_id)) {
              case '5':
                return (
                  Array.isArray(d.files) &&
                  d.files.map((f: any, fileIndex: number) => {
                    const fileKey = typeof f === 'object' ? f.upload_id || f.name || fileIndex : f;
                    return (
                      <File
                        file={f}
                        onRemove={onRemoveFile}
                        itemIndex={index}
                        index={fileIndex}
                        key={`file-${index}-${fileKey}`}
                      />
                    );
                  })
                );
              case '24':
                return (
                  <Nutror
                    nutror={d}
                    onRemove={onRemoveDelivery}
                    onEdit={onEditDelivery}
                    index={index}
                    key={`nutror-${index}`}
                  />
                );
              case '47':
                return (
                  <Alpaclass
                    other={d}
                    onRemove={onRemoveDelivery}
                    onEdit={onEditDelivery}
                    index={index}
                    key={`other-${index}`}
                    offer={offer}
                  />
                );
              default:
                return (
                  <Other
                    deliveries={deliveries}
                    other={d}
                    onRemove={onRemoveDelivery}
                    onEdit={onEditDelivery}
                    index={index}
                    key={`other-${index}`}
                    offer={offer}
                  />
                );
            }
          })
        ) : (
          <li className='px-4 py-2'>
            <span className='text-gray-500'>Nenhuma entrega cadastrada</span>
          </li>
        )}
      </ul>
      <ModalActions title='Atenção' open={open} onClose={handleClose} onOk={onOk} buttonOk='Excluir'>
        <p>{`Você realmente deseja excluir a entrega ${item} ?`}</p>
      </ModalActions>
    </>
  );
};

export default DeliveryList;
